import React, { useState } from 'react'
import RetroCardItem from './RetroCardItem'

const RetroColumn = ({
  title,
  column,
  cards,
  onAdd,
  canRemove,
  onRemove,
  reactedIds,
  onToggleReact,
  onComment,
  isMaster,
  onTogglePin,
  canRemoveComment,
  onRemoveComment,
}) => {
  const [text, setText] = useState('')

  const submit = () => {
    if (!text.trim()) return
    onAdd(column, text)
    setText('')
  }

  return (
    <div className={`retro-column retro-column-${column}`}>
      <div className="retro-column-header">
        <h2 className="retro-column-title">{title}</h2>
        <span className="retro-column-count">({cards.length})</span>
      </div>

      <div className="retro-cards">
        {cards.length === 0 && <p className="retro-empty-hint">Nenhum cartão ainda</p>}
        {cards.map((card) => (
          <RetroCardItem
            key={card.id}
            card={card}
            canRemove={onRemove && canRemove(card)}
            onRemove={onRemove}
            reacted={reactedIds.has(card.id)}
            onToggleReact={onToggleReact}
            onComment={onComment}
            isMaster={isMaster}
            onTogglePin={onTogglePin}
            canRemoveComment={canRemoveComment}
            onRemoveComment={onRemoveComment}
          />
        ))}
      </div>

      <div className="retro-add-form">
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          placeholder="Adicionar..."
          maxLength={300}
        />
        <button type="button" className="retro-add-button" onClick={submit} disabled={!text.trim()}>
          +
        </button>
      </div>
    </div>
  )
}

export default RetroColumn
